import {axiosInstance} from '../axios';
import {wishlist_apis} from '../ApiConst';


export const Add_To_Wishlist = async (userToken, id) => {
//   let userToken1 = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);
  const data = {
    product_id: id,
  };

//   return await axios.post(`${base_url}api/v0/orders/wishlist/`, data, {
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Token ${userToken1}`,
//     },
//   });
return await axiosInstance.post(wishlist_apis.add_to_wishlist, data, {useUserToken: true})
};


export const View_Wishlist = async (userToken) => {
//   let userToken1 = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);

//   return await axios.get(`${base_url}api/v0/orders/wishlist/`, {
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Token ${userToken1}`,
//     },
//   });
return await axiosInstance.get(wishlist_apis.view_wishlist, {useUserToken: true})
};


export const Delete_Wishlist = async (userToken, id) => {
    
//   let userToken1 = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);

//   return await axios.delete(`${base_url}api/v0/orders/wishlist/`, {
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Token ${userToken1}`,
//     },
//     data: {
//       product_id: Number(id),
//     },
//   });
return await axiosInstance.delete(wishlist_apis.delete_wishlist, {useUserToken: true, data: {product_id: Number(id)}})
};


